import React from 'react';
import { useSmartTranslation } from '../../hooks/useStudentLabel';

const STATUS_CONFIG = {
  scheduled:   { labelKey: 'treatments.scheduled',   fallback: 'Scheduled',   color: 'var(--color-info-dark, #2563EB)', bg: 'var(--color-info-light, #EFF6FF)' },
  confirmed:   { labelKey: 'treatments.confirmed',   fallback: 'Confirmed',   color: 'var(--cat-cyan-fg, #0891B2)', bg: 'var(--cat-cyan-bg, #ECFEFF)' },
  in_progress: { labelKey: 'treatments.inProgress',  fallback: 'In Progress', color: 'var(--color-warning-dark, #D97706)', bg: 'var(--color-warning-light, #FFFBEB)' },
  completed:   { labelKey: 'treatments.completed',   fallback: 'Completed',   color: 'var(--color-success-dark, #16A34A)', bg: 'var(--color-success-light, #F0FDF4)' },
  no_show:     { labelKey: 'treatments.noShow',      fallback: 'No-Show',     color: 'var(--color-danger-dark, #DC2626)', bg: 'var(--color-danger-light, #FEF2F2)' },
  cancelled:   { labelKey: 'treatments.cancelled',   fallback: 'Cancelled',   color: 'var(--color-text-secondary, #6B7280)', bg: 'var(--color-surface-alt, #F3F4F6)' },
};

// Auto-calculate effective status:
// scheduled → confirmed (accepted by default)
// confirmed + within treatment time window → in_progress
function getEffectiveStatus(rawStatus, date, time, endTime) {
  if (rawStatus === 'scheduled') return 'confirmed';
  if (rawStatus === 'confirmed') {
    const now = new Date();
    const today = now.toISOString().split('T')[0];
    if (date === today && time) {
      const [h, m] = time.split(':').map(Number);
      const startMin = h * 60 + m;
      let endMin = startMin + 60;
      if (endTime) {
        const [eh, em] = endTime.split(':').map(Number);
        endMin = eh * 60 + em;
      }
      const nowMin = now.getHours() * 60 + now.getMinutes();
      if (nowMin >= startMin && nowMin <= endMin) return 'in_progress';
    }
    return 'confirmed';
  }
  return rawStatus || 'scheduled';
}

export default function TreatmentStatusBadge({ status, date, time, endTime }) {
  const t = useSmartTranslation();
  const effectiveStatus = getEffectiveStatus(status, date, time, endTime);
  const config = STATUS_CONFIG[effectiveStatus] || STATUS_CONFIG.scheduled;

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '2px 10px',
        borderRadius: 999,
        fontSize: '0.75rem',
        fontWeight: 600,
        background: config.bg,
        color: config.color,
        whiteSpace: 'nowrap',
      }}
    >
      {t(config.labelKey, { defaultValue: config.fallback })}
    </span>
  );
}

export { STATUS_CONFIG, getEffectiveStatus };
